import Loader from 'components/Modals/Loader';
import PrivateRoute from 'components/Router/PrivateRoute';
import RouteWithProps from 'components/Router/RouteWithProps';
import routes from 'constant/routes';
import { eventsToDispatch } from 'helpers/events';
import { getAuthToken } from 'helpers/utils';
import React, { useEffect, useState } from 'react';
import { BrowserRouter, Switch } from 'react-router-dom';
import Login from 'views/Login';

import App from './App';
// @ts-expect-error ts-migrate(2307) FIXME: Cannot find module 'admin/Dashboard' or its corres... Remove this comment to see the full error message
const Dashboard = React.lazy(() => import('admin/Dashboard'));
import eventEmitter from 'services/eventEmitter';

eventEmitter.getInstance();

const MainApp = () => {
    const token = getAuthToken();
    const [isLoggedIn, setIsLoggedIn] = useState(!!token);
    const [showDashboard, toggleDashboard] = useState(0);

    const [, setRender] = useState(false);

    const tabRedirect = () => setRender((val) => !val);

    const loginUpdated = (event: $TSFixMe) => {
        setIsLoggedIn(event.detail);
    };

    const toggleLayout = ({ detail }: $TSFixMe) => {
        toggleDashboard(detail.layout);
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            window.addEventListener(eventsToDispatch.LOGIN_SUCCESS, loginUpdated);
            window.addEventListener(eventsToDispatch.TOGGLE_LAYOUT, toggleLayout);
        }
        return () => {
            if (typeof window !== 'undefined') {
                window.removeEventListener(eventsToDispatch.LOGIN_SUCCESS, loginUpdated);
                window.removeEventListener(eventsToDispatch.TOGGLE_LAYOUT, toggleLayout);
            }
        };
    }, []);

    useEffect(() => {
        const body = document.getElementsByTagName('body')[0];
        if (body) {
            body.style.margin = '0';
        }

        if (typeof window !== 'undefined') {
            window.addEventListener(eventsToDispatch.TAB_REDIRECT, tabRedirect);
        }
        return () => {
            if (typeof window !== 'undefined') {
                window.removeEventListener(eventsToDispatch.TAB_REDIRECT, tabRedirect);
            }
        };
    }, []);

    return (
        <BrowserRouter>
            <Switch>
                <RouteWithProps
                    component={Login}
                    exact={true}
                    props={{ isLoggedIn }}
                    path="/login"
                />
                <PrivateRoute
                    component={() => (
                        <React.Suspense fallback={<Loader />}>
                            {showDashboard === 0 ? (
                                <Dashboard
                                    component={App}
                                    menuItems={routes.items[0].tabs
                                        .filter((y: $TSFixMe) => y.type === 'link')
                                        .map((x: $TSFixMe) => ({
                                            children: [],
                                            css_class: `icon icn-${x.name}`,
                                            display_name: x.name,
                                            id: x.name,
                                            menu_item_type: 'menu',
                                            name: x.name,
                                            position: 120,
                                            slug: x.name,
                                            url: '#' + x.path,
                                            visible: true
                                        }))}
                                />
                            ) : (
                                <App />
                            )}
                        </React.Suspense>
                    )}
                    path="/"
                    isLoggedIn={isLoggedIn}
                />
            </Switch>
        </BrowserRouter>
    );
};

export default MainApp;
